<template>
  <div class="notificaciones">

    <el-dropdown size="large" placement="bottom-end" trigger="click" popper-class="dropdown-notification-popover"
      ref="refDropdown" :teleported="false">

      <el-badge :value="cantidad" class="el-dropdown-link" color="#35656f">
        <font-awesome-icon icon="fas fa-bell" size="2x" color="white" />
      </el-badge>

      <template #dropdown>
        <!-- Header -->
        <li class="dropdown-menu-header">
          <div class="dropdown-header d-flex py-1 align-items-center">
            <h4 class="notification-title mb-0 me-auto">
              Notificaciones
            </h4>
            <span class="fst-bolder">{{ cantidad }} sin leer</span>
          </div>

          <div class="dropdown-header pb-1 pt-0" v-if="sinleer.length > 0">

            <b-button-group size="sm">
              <b-button variant="outline-dark" @click="todoleido()" size="sm"
                v-b-tooltip.hover.top="'Marcar todos como leído'">
                Marcar todos como leído
              </b-button>

              <b-button variant="outline-dark"
                v-if="formulario.notificaciones.filter(val => val.seleccionado).length > 0" @click="marcarLeido()"
                v-b-tooltip.hover.top="'Marcar como leídos'">
                <font-awesome-icon icon="fas fa-eye" />
              </b-button>

              <b-button variant="outline-dark"
                v-if="formulario.notificaciones.filter(val => val.seleccionado).length > 0"
                @click="eliminarSeleccionadas()" v-b-tooltip.hover.top="'Eliminar seleccionadas'">
                <font-awesome-icon icon="fas fa-trash" />
              </b-button>

            </b-button-group>


          </div>
        </li>


        <b-tabs content-class="mt-0 content-tabs" fill pills end nav-wrapper-class="mt-2 mb-0 ">
          <b-tab>
            <template #title>
              <el-badge :value="sinleer.length">
                <strong class="me-1">Sin leer</strong>
              </el-badge>
            </template>

            <section style="height:300px; overflow-y:auto">

              <b-form-checkbox size="lg" inline v-for="(notification, i) in formulario.notificaciones" :key="i"
                v-model="notification.seleccionado" class="d-flex align-items-center">

                <b-link class="notificacion-list">
                  <section @click="verNotificacion(notification)" class="d-flex">
                    <aside class="flex-grow-0 d-flex align-items-center" v-if="notification.data">
                      <avatar v-if="notification.data.usuario" :src="notification.data.avatar"
                        :text="notification.data.usuario" :variant="notification.data.type" :size="48" class="me-1" />

                      <font-awesome-icon icon="fas fa-check" size="sm" class="mx-1" v-else />
                    </aside>

                    <main class="d-flex flex-column align-items-start justify-content-start flex-grow-1">
                      <p class="lh-sm my-0 ">
                        <span class="fw-bolder lh-sm" v-if="notification.data">
                          {{ notification.data.titulo }}
                        </span>
                      </p>
                      <small class="" v-if="notification.data">
                        {{ notification.data.mensaje[0].substring(0, 30) }}...(seguir leyendo)
                      </small>
                    </main>
                  </section>

                </b-link>
              </b-form-checkbox>

            </section>
          </b-tab>

          <b-tab>

            <template #title>
              <el-badge :value="leidas.length">
                <strong class="me-1">Leídos</strong>
              </el-badge>
            </template>

            <section style="height:300px; overflow-y:auto">

              <b-link v-for="(notification, i) in leidas" :key="notification.id" class="notificacion-list ">

                <section class="d-flex my-1" @click="verNotificacion(notification)">

                  <aside class="flex-grow-0 d-flex align-items-center justify-content-end">
                    <avatar v-if="notification.data.usuario" :src="notification.data.avatar"
                      :text="notification.data.usuario" :size="48" />
                    <font-awesome-icon icon="fas fa-check" v-else size="1x" />

                  </aside>

                  <section class="flex-grow-1 ps-1">

                    <b-container fluid>
                      <b-row>
                        <div class="col-12 col-md-8 ">
                          <p class="my-0 lh-sm fw-bolder">
                            <span class="lh-sm fs-bolder">
                              {{ notification.data.titulo }}
                            </span>
                          </p>
                          <small class="notification-text">
                            {{ notification.data.mensaje[0].substring(0, 30) }}...(seguir leyendo)
                          </small>
                        </div>

                        <div class="col-12 col-md-4">
                          <b-button-group size="sm" class="btns">
                            <b-button variant="text" v-b-tooltip.hover.top="'Eliminar Notificación'"
                              @click.stop="eliminarNotification(notification.id)">
                              <font-awesome-icon icon="fas fa-trash" size="1x" />
                            </b-button>

                            <b-button variant="text" v-b-tooltip.hover.top="'Marcar como no leída'"
                              @click.stop="noshowNotificacion(notification.id)">
                              <font-awesome-icon icon="fas fa-eye-slash" size="1x" />
                            </b-button>
                          </b-button-group>
                        </div>
                      </b-row>

                    </b-container>

                  </section>
                </section>

              </b-link>
            </section>

          </b-tab>
        </b-tabs>

      </template>

    </el-dropdown>

    <el-dialog v-model="showNotification" footer-class="d-flex" @closed="cerrarNotification" align-center center
      :close-on-press-escape="false" :close-on-click-modal="false" :z-index="1035" :width="anchoSidebar"
      :append-to-body="false" append-to="html">

      <template #header>
        <section class="d-flex align-items-center">
          <h4 class="">{{ notification.data.titulo }}</h4>
        </section>
      </template>

      <p v-for="(mensaje, i) in notification.data.mensaje" :key="i">{{ mensaje }}</p>

      <template #footer>
        <b-button-group size="sm" class="me-auto m-sta">
          <b-button @click="irNotification(notification.data.url)" v-if="notification.data.btn" variant="primary"
            size="sm" class="">
            {{ notification.data.btnTitle }}
          </b-button>
        </b-button-group>

      </template>

    </el-dialog>



  </div>
</template>

<script setup>
  import {ref,onMounted, watch,toRefs,computed, onUnmounted,inject} from 'vue';
  
  import {useRouter} from 'vue-router';
  import { useSound } from '@vueuse/sound'
  import notificacionSound from 'sonidos/notificacion-sound.mp3';
  import useUsuarioStore from '@/store/usuario';
  import useNotficacionStore from '@/store/notificacion';
  import Avatar from '@components/avatar.vue';
  import { storeToRefs } from 'pinia';
  import useUtils from '@composables/useUtils';
  const notificacion_store = useNotficacionStore();
  
  const usuario_store = useUsuarioStore();
  
  const { play } = useSound(notificacionSound)
  const { sinleer, leidas } = storeToRefs(notificacion_store);
  const {usuario} = storeToRefs(usuario_store);
  const usuario_id = computed(() => usuario.value.id);
  const router = useRouter();

  const {
    anchoSidebar,
    loading
  } = useUtils();

  const showNotification = ref(false);
  const refDropdown = ref(null);
  let seleccionados = ref([]);

  let formulario  = ref({
      notificaciones:[]
  })


  let cargarForm = () => {
      formulario.value.notificaciones = sinleer.value.map(val => {
      return {
        id:val.id,
        seleccionado:false,
        created_at:val.created_at,
        type:val.type,
        data:val.data,
      }
    })
  }
  
  let modalNotificacion = ref(null);
    
    const cargarNotificaciones = (usuario_id) => {
      if (usuario_id) notificacion_store.cargarNotificaciones(usuario_id);
    } 

    const montarEcho = () => {
      if (usuario_id.value) {
        Echo.private(`usuario.${usuario.value.id}`)
          .notification((noti) => {
            notificacion_store.pushNotificacionSinLeer(noti);
            cargarForm();
            play()
          });
      }
    }

    onMounted(() => {
      cargarNotificaciones(usuario.value.id)
      montarEcho();

    })

   

    onUnmounted(() => {
      Echo.leave(`usuario.${usuario_id.value}`)
    })
   
    const getFecha = (fecha) => {
        return moment(fecha).format('LLL');

    } 

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      // wheelPropagation: false,
    }

    const notification = ref({
      id:null,
      created_at:'',
      read_at:null,
      data:{
        titulo:''
      }
    });
    
   const verNotificacion = (notificat) => {
      notification.value = notificat
      showNotification.value = true;
   }


    const cerrarNotification = () => {
      if(!notification.value.read_at){
        
        notificacion_store.marcarLeida({ usuario: usuario_id.value, notificacion: notification.value.id })
        .then(({success,notificacion : notif}) => {
          if(success){
            notificacion_store.pushLeida(notif);
            toast.info('Notificación marcada como leída');
          }else{
            toast.info('No se pudo marcar como leída, inténtelo de nuevo');
          }
        }).catch(e => console.log(e));

      }

    }

    const irNotification = (url) => {
      showNotification.value = false;
      router.push(url);
    }

    const refreshNotificacion = () => {
      if (usuario.value.id) cargarNotificaciones(usuario.value.id);
    }

    const showNotificacion = (notification_id) => {

        notificacion_store.marcarLeida({usuario:usuario.value.id,notificacion:notification_id})
            .then(() => {
              cargarNotificaciones(store.state.usuario.usuario.id)
              toast.info('Notificación marcada como leída');
            }).catch(e => console.log(e));
    }

    const noshowNotificacion = (notificacion_id) => {


        notificacion_store.marcarNoLeida({usuario:usuario.value.id,notificacion:notificacion_id})
        .then(({data}) => {
          if(data.result){
            toast.info('Se ha marcado como no leída')
          }else{
            toast.info('No se pudo marcar como no leída, inténtelo de nuevo')
          }
        }).catch(e => {
          console.log(e)
        }).finally(() => cargarNotificaciones(usuario.value.id))

    } 

    const eliminarNotification = (notification_id) => {


      notificacion_store.eliminar({notificacion:notification_id,usuario:usuario.value.id})
      .then(({result}) => {
        if(result){
          toast.info('Se ha eliminado con éxito la notificación.')
          cargarNotificaciones(usuario.value.id);
        }else{
          toast.info('No se pudo eliminar la notificación, inténtelo de nuevo mas tarde.')
        }
      }).catch(e => {
        console.log(e)
      })

    }

    const todoleido = () => {

      notificacion_store.todoleido(usuario.value.id)
      .then(({data}) => {
        
        if(data.result){
          toast.info('Se han marcado todas las notificaciones como leídas')
          cargarNotificaciones(usuario.value.id);
        }else{
          toast.info('Error en servidor, inténtelo de nuevo mas tarde')
        }

      }).catch(e => {
        console.log(e)
      });

    }

    const marcarLeido = () => {

      notificacion_store.marcarSeleccionadosLeidos({
        usuario:usuario.value.id,
        seleccionados:formulario.value.notificaciones.filter(val => val.seleccionado)
      })
      .then(({data}) => {
        if(data.result){
          cargarNotificaciones(usuario.value.id);
        }else{
          toast.info('La operación no tuvo éxito, inténtelo de nuevo mas tarde.')
        }

      }).catch(e => {
        console.log(e)
      });

    }

    const eliminarSeleccionadas = () => {

      notificacion_store.eliminarSeleccionados({
        usuario:usuario.value.id,
        seleccionados:formulario.value.notificaciones.filter(val => val.seleccionado)
      })
      .then(({result}) => {

        if(result){
          cargarNotificaciones(usuario.value.id);
        }else{
          toast.info('La operación no tuvo éxito, inténtelo de nuevo mas tarde.')
        }

      }).catch(e => {
        console.log(e)
      });

    }

    watch(usuario,(val) => {
      cargarNotificaciones(usuario.value.id);
    })

    watch(sinleer,(val) => {
      cargarForm();
    })

    watch(usuario_id, (val) => {
      Echo.leave(`usuario.${val}`);
      montarEcho();
    })

    const cantidad = computed(() => notificacion_store.cantidad);

    
</script>

<style lang="scss" scoped>

.notificacion-list:hover{
  .btns{
    display: flex !important;
  }
  
}

.btns{
  display: none;
}
// .scroll-area {
//   position: relative;
//   margin: auto;
//   width: 400px;
//   height: 300px;
// }


    :deep(.dropdown-notification-popover) {
        padding: 0px 1rem !important;
        flex: 1 1 auto !important;
        min-width:320px;


        .nav-link.active{
          color:white;
        }
    
      .content-notificacion {
        min-width:320px;
        width:350px;
        overflow-y: auto;
        display: flex;
        justify-content: space-between;
        align-content: flex-start;
        flex-wrap: wrap;
        
        >div {
          flex: 1 1 auto;
        }


      
      }


      @media (min-width:720px){

        min-width:450px;
        width: auto;

        .content-notificacion {
          min-width: 400px;
          width: 450px;
        }
      }
      
     
    }


    


</style>


